import { Button, Modal } from '@trackman/web-shared-components';
import React from 'react';
import styled from 'styled-components';
import { black, grey } from 'styles/Colors';
import { DotsWrapper } from '../GameDialog/components/Dots/DotsStyles';

export const Body = styled.div`
  padding: 29px 41px 0 39px !important;
`;

export const GameRow = styled.div`
  margin-top: 25px;
  display: flex;
  justify-content: space-between;
  position: relative;
`;

export const OrganizationSubtitle = styled.div`
  position: absolute;
  bottom: -16px;
  font-family: Lato;
  font-size: 11px;
  line-height: 1.45;
  letter-spacing: 0.5px;
  color: ${grey};
`;

export const StyledModal = styled((props) => <Modal {...props} />)`
  .MuiPaper-root {
    width: 546px !important;
    .content {
      padding: 29px 41px 0 39px !important;
      border: none;
      overflow-y: initial;
    }
  }
`;

export const DialogFooter = styled.div`
  height: 104px;
  padding: 0;
  display: flex;
  justify-content: space-between;
  ${DotsWrapper} {
    margin-top: 40px;
    position: absolute;
  }
`;

export const StyledButton = styled((props) => <Button {...props} />)`
  margin-top: 32px;
  margin-left: auto;
`;
